import React, { Children } from 'react'
import styled from '@emotion/styled'
import {
  CancelIcon,
  Container,
  ForstaLogo,
  Row,
  color,
  spacer,
  withTheme
} from 'stylist'
import { Link } from 'react-router-dom'

const ANIMATION_STAGGER_DELAY = 50

const MenuBackdrop = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: hidden;
  background: ${color('white')};
  max-height: ${props => (props.open ? '100%' : '0')};
  transition: max-height 350ms ease;
  z-index: 3;
`

const MenuHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;

  @supports (display: grid) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 70px;
    height: auto;
  }
`

const Dismiss = styled(CancelIcon)`
  display: flex;
  justify-content: flex-end;
  transform: translateX(0.5rem);

  @supports (display: grid) {
    display: block;
    justify-self: end;
  }
`

const MenuLinkContainer = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    transform: ${({ open }) =>
      open ? 'none' : 'scale(1.1) translateY(-1.5rem)'};
    transition: all 0.5s;
    opacity: ${({ open }) => (open ? 1 : 0)};
    ${({ children }) =>
      [...Array(Children.count(children)).keys()]
        .map(
          n =>
            `&:nth-child(${n + 1}) {
              transition-delay: ${(n + 1) * ANIMATION_STAGGER_DELAY}ms;
            }`
        )
        .join('\n')};
  }
`

const ItemContainer = styled.li`
  border-bottom: 1px solid ${color('silver')};
`

const StyledA = styled.a`
  display: block;
  width: 100%;
  padding: ${spacer(3)} 0;
`
const StyledLink = styled(Link)`
  display: block;
  width: 100%;
  padding: ${spacer(3)} 0;
`

const Item = withTheme(({ children, href, theme, to }) => (
  <ItemContainer>
    {href ? (
      <StyledA href={href}>
        {children}
      </StyledA>
    ) : (
      <StyledLink to={to}>
        {children}
      </StyledLink>
    )}
  </ItemContainer>
))

const HamburgerMenu = ({ children, onClose, open }) => (
  <MenuBackdrop open={open}>
    <Row>
      <Container>
        <MenuHeader>
          <Link onClick={onClose} to="/">
            <ForstaLogo size="sm" />
          </Link>
          <Dismiss cursor="pointer" width={30} height={30} onClick={onClose} />
        </MenuHeader>
        <MenuLinkContainer open={open}>{children}</MenuLinkContainer>
      </Container>
    </Row>
  </MenuBackdrop>
)

HamburgerMenu.Item = Item

export default HamburgerMenu



// WEBPACK FOOTER //
// ./src/routes/components/HamburgerMenu.js